var search = require('./search');

module.exports = function ($searchControl, cacheName, endpoint) {    
    if ($searchControl.length) {
        window[cacheName] = {};

        var $searchInput = $searchControl.find('.search-control__search-input');
        var $typeAheadHidden = $searchControl.find('.search-control__type-ahead-hidden-text');
        var $typeAheadVisible = $searchControl.find('.search-control__type-ahead-visible-text');
        var $suggestionsWrapper = $searchControl.find('.search-control__search-suggestions-wrapper').first();

        var initialValue = $searchInput.data('initialValue');
        if (initialValue) {
            $searchInput.val(initialValue);
        }

        var clearTypeAhead = function () {
            $typeAheadHidden.text('');
            $typeAheadVisible.text('');
        };

        var commandCharacters = [ICF.Variables.TypeAhead.Enter, ICF.Variables.TypeAhead.Esc, ICF.Variables.TypeAhead.Tab, ICF.Variables.TypeAhead.DownArrow, ICF.Variables.TypeAhead.UpArrow];
        var ignoreCharacters = [ICF.Variables.TypeAhead.LeftArrow, ICF.Variables.TypeAhead.RightArrow];
        
        $searchInput.on('keyup', function (e) {            
            var keyCode = e.which || e.keyCode;            
            if (!commandCharacters.includes(keyCode) && !ignoreCharacters.includes(keyCode)) {                
                var currentVal = $searchInput.val();

                if (currentVal.length >= ICF.Variables.TypeAhead.MinQueryLength) {                    
                    if (currentVal in window[cacheName]) {
                        updateSuggestions(window[cacheName][currentVal], currentVal);
                        return;
                    }

                    clearTypeAhead();

                    search(endpoint, currentVal, function (results) {
                        if (results && results.suggestions && results.suggestions.length) {
                            window[cacheName][currentVal] = results.suggestions;
                            updateSuggestions(results.suggestions, currentVal);
                        }
                        else {
                            clearTypeAhead();
                            deactivateSuggestions();
                        }
                    });
                }
                else {
                    clearTypeAhead();
                    deactivateSuggestions();
                }
            }              
            else if (keyCode === ICF.Variables.TypeAhead.Esc) {
                e.preventDefault();
                deactivateSuggestions();                
                clearTypeAhead();                
            }
            else if (keyCode === ICF.Variables.TypeAhead.DownArrow) {                
                var $activeSearchSuggestionsWrapper = $searchControl.find('.search-control__search-suggestions-wrapper--active');
                if ($activeSearchSuggestionsWrapper.length) {
                    var $activeSuggestion = activeSuggestion();
                    if ($activeSuggestion.length) {

                        var $suggestionToActivate = $activeSuggestion.next();
                        if (!$suggestionToActivate.length) {
                            $suggestionToActivate = $activeSearchSuggestionsWrapper.find('.search-control__search-suggestion').first();
                        }

                        deactivateSuggestion($activeSuggestion);
                        if ($suggestionToActivate.length) {
                            activateSuggestion($suggestionToActivate);
                        }
                    }
                    else {
                        var $suggestionToActivate = $activeSearchSuggestionsWrapper.find('.search-control__search-suggestion').first();
                        if ($suggestionToActivate.length) {
                            activateSuggestion($suggestionToActivate);
                        }
                    }
                    $activeSuggestion = activeSuggestion();
                    if ($activeSuggestion.length) {
                        selectSuggestion($activeSuggestion, false, false);
                    }

                    e.preventDefault();
                }
            }
            else if (keyCode === ICF.Variables.TypeAhead.UpArrow) {                
                var $activeSearchSuggestionsWrapper = $searchControl.find('.search-control__search-suggestions-wrapper--active');
                if ($activeSearchSuggestionsWrapper.length) {
                    var $activeSuggestion = activeSuggestion();
                    if ($activeSuggestion.length) {
                        
                        var $suggestionToActivate = $activeSuggestion.prev();
                        if (!$suggestionToActivate.length) {
                            $suggestionToActivate = $activeSearchSuggestionsWrapper.find('.search-control__search-suggestion').last()
                        }

                        deactivateSuggestion($activeSuggestion);
                        if ($suggestionToActivate.length) {
                            activateSuggestion($suggestionToActivate);
                        }
                    }
                    else {                        
                        var $suggestionToActivate = $activeSearchSuggestionsWrapper.find('.search-control__search-suggestion').last();
                        if ($suggestionToActivate.length) {
                            activateSuggestion($suggestionToActivate);
                        }
                    }

                    $activeSuggestion = activeSuggestion();
                    if ($activeSuggestion.length) {
                        selectSuggestion($activeSuggestion, false, false);
                    }
                    
                    e.preventDefault();
                }
            }
            else if (keyCode === ICF.Variables.TypeAhead.Enter) {
                var $activeSuggestion = activeSuggestion();
                if ($activeSuggestion.length) {                    
                    selectSuggestion($activeSuggestion);
                }
                else {
                    $searchControl.find('.search-control__search-form').submit();
                }
            }
        });

        $searchInput.on('keydown', function (e) {            
            var keyCode = e.which || e.keyCode;      
            if (keyCode === ICF.Variables.TypeAhead.Tab) {                
                deactivateSuggestions();
            }
            else if (commandCharacters.includes(keyCode)) {
                e.preventDefault();
                return false;
            }            
        });
        
        $searchControl.on('click', '.search-control__search-suggestions-wrapper--active .search-control__search-suggestion', function (e) {
            selectSuggestion($(e.target));
        });

        var activeSuggestion = function () {
            return $searchControl.find('.search-control__search-suggestions-wrapper .search-control__search-suggestion--active');
        }

        var activateSuggestion = function ($suggestion) {
            $suggestion.addClass('search-control__search-suggestion--active');
            $suggestion.attr('aria-selected', 'true');
            $searchInput.attr('aria-activedescendant', $suggestion[0].id);
        }

        var deactivateSuggestion = function ($suggestion) {
            $suggestion.removeClass('search-control__search-suggestion--active');
            $suggestion.attr('aria-selected', 'false');
            $searchInput.removeAttr('aria-activedescendant');
        }

        var deactivateSuggestions = function () {
            var $suggestionsWrapper = $searchControl.find('.search-control__search-suggestions-wrapper');
            var $activeSuggestion = activeSuggestion();
            if ($activeSuggestion.length) {
                deactivateSuggestion($activeSuggestion);
            }
                        
            $searchControl.find('.search-control__suggestion-announce').empty();
            $searchInput.removeAttr('aria-activedescendant');
            $suggestionsWrapper.removeClass('search-control__search-suggestions-wrapper--active');
        }

        var activateSuggestions = function () {
            var $suggestionsWrapper = $searchControl.find('.search-control__search-suggestions-wrapper');                       
            $suggestionsWrapper.addClass('search-control__search-suggestions-wrapper--active');

            var numberOfSuggestions = $suggestionsWrapper.find('.search-control__search-suggestion').length;
            var suggestionWord = numberOfSuggestions == 1 ? "suggestion" : "suggestions";
            var announceText = numberOfSuggestions + " " + suggestionWord + " found, to navigate use up and down arrows.";
            var announceDiv = $searchControl.find('.search-control__suggestion-announce');
            if (announceDiv.text() !== announceText) {
                announceDiv.text(announceText);
            }                
        }

        var updateSuggestions = function (suggestions, val) {
            if ($searchInput.val() !== val) {
                return;
            }
            
            var typeAheadValue = '';
            if ($searchInput.val().trim() == suggestions[0] && suggestions.length > 1) {
                typeAheadValue = suggestions[1];
            }
            else {
                typeAheadValue = suggestions[0];
            }

            $typeAheadHidden.text(val);
            $typeAheadVisible.text(typeAheadValue.substring(val.length));

            $searchInput.removeAttr('aria-activedescendant');
            var suggestionsListbox = $suggestionsWrapper.children('.search-control__search-suggestions').first();
            suggestionsListbox.empty();
            
            if (suggestions.length > 1 || (suggestions.length == 1 && suggestions[0] !== $searchInput.val().trim())) {                
                for (var suggestion in suggestions) {
                    suggestionsListbox.append("<div role='option' aria-selected='false' tabindex='-1' class='search-control__search-suggestion' id='suggestion-" + (parseInt(suggestion) + 1) + "'>" + suggestions[suggestion] + "</div>");
                }
                activateSuggestions();
            }
            else {
                deactivateSuggestions();
            }
        };

        var selectSuggestion = function ($suggestion, shouldSubmitForm, shouldHideSuggestions) {
            shouldSubmitForm = typeof shouldSubmitForm !== 'undefined' ? shouldSubmitForm : true;
            shouldHideSuggestions = typeof shouldSubmitForm !== 'undefined' ? shouldHideSuggestions : true;           
            
            if (shouldHideSuggestions) {
                deactivateSuggestions();
            }
            
            clearTypeAhead();
            $searchInput.val($suggestion[0].innerText);

            if (shouldSubmitForm) {
                $searchInput.closest('.search-control__search-form').submit();
            }                        
        }
    }
};